import { render, staticRenderFns } from "./Profile3.vue?vue&type=template&id=05eef19a&"
import script from "./Profile3.vue?vue&type=script&lang=js&"
export * from "./Profile3.vue?vue&type=script&lang=js&"
import style0 from "./Profile3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports